import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  base: {
    display: 'inline-block',
    padding: '4px 8px',
    fontWeight: 'bold',
    lineHeight: '16px',
    color: '#fff',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    backgroundColor: '#3bb549',
    borderRadius: '3px',
    fontSize: '13px',
  },
  requested: {
    backgroundColor: '#F7931E',
  },
  approved: {
    backgroundColor: '#004D71',
  },
  denied: {
    backgroundColor: '#F00',
  },
  cancelled: {
    backgroundColor: '#999',
  },
  completed: {
    backgroundColor: '#8CC63F',
  },
}));

const Status = ({ value }) => {
  const classes = useStyles();
  switch (value) {
    case 'requested':
      return <span className={`${classes.base} ${classes.requested}`}>Solicitado</span>;
    case 'approved':
      return <span className={`${classes.base} ${classes.approved}`}>Aprobada</span>;
    case 'denied':
      return <span className={`${classes.base} ${classes.denied}`}>Denegada</span>;
    case 'cancelled':
      return <span className={`${classes.base} ${classes.cancelled}`}>Cancelada</span>;
    default:
      return <span className={`${classes.base} ${classes.completed}`}>Completada</span>;
  }
};

export default Status;
